import { FC, useMemo, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { AppLoader } from 'components/Core/AppLoader';
import PointsCategoriesTable from 'components/Tables/PointsCategoriesTable/PointsCategoriesTable';
import ProductCategoriesTable from 'components/Tables/ProductCategoriesTable/ProductCategoriesTable';
import { CategoriesEntity } from 'stores/categories/types';
import { categoriesTranslations } from './translations';
import { CategoriesTransFields } from './types';
import { tabs } from './constatnts';
import styles from './categories.module.scss';

const Categories: FC = () => {
  const {
    mainStore: { user, getMobileLanguagesList, mobileLanguages },
    categoriesStore: { getCategoriesData },
  } = useStore();

  const { t } = useMyTranslations<CategoriesTransFields>([categoriesTranslations.name]);

  const { entity } = useParams();
  const navigate = useNavigate();

  const {} = useQuery('getMobileLanguagesList', getMobileLanguagesList, {
    enabled: !mobileLanguages?.length,
    retry: false,
  });

  const { mutate, isLoading } = useMutation(getCategoriesData, {
    mutationKey: 'getCategoriesData',
    retry: false,
  });

  useEffect(() => {
    mutate(entity as CategoriesEntity);
  }, [entity, user?.selectedCountryCode]);

  const onChangeTab = (tab: CategoriesEntity) => {
    if (tab !== entity) {
      navigate(`/categories/${tab}`);
    }
  };

  const requestsTable = useMemo(() => {
    switch (entity) {
      case 'points-categories':
        return <PointsCategoriesTable />;
      case 'product-categories':
        return <ProductCategoriesTable />;
      default:
        return null;
    }
  }, [entity]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.tabs}>
        {tabs.map((item) => (
          <button
            key={item}
            className={`${styles.tab}  ${entity === item && styles.tabCurrent}`}
            type='button'
            onClick={() => onChangeTab(item)}
            disabled={isLoading}>
            <span className={styles.btnTitle}>{item}</span>
            {/* <span className={styles.count}>{requestsStore[item.countKey] || 0}</span> */}
          </button>
        ))}
      </div>
      <div className={styles.container}>{isLoading ? <AppLoader /> : requestsTable}</div>
    </main>
  );
};

export default observer(Categories);
